/**
 * Created by Alex Aguilar on 3/31/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('modelAircraftService', modelAircraftService);

    modelAircraftService.$inject = ['$http', 'CONFIG', 'messageService'];

    function modelAircraftService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/modelAircrafts';

        var service = {
            getModelAircrafts: getModelAircrafts,
            getPageModelAircrafts: getPageModelAircrafts,
            getModelAircraft: getModelAircraft,
            saveModelAircraft: saveModelAircraft,
            updateModelAircraft: updateModelAircraft,
            deleteModelAircraft: deleteModelAircraft,
            getModelAircraftByMaker: getModelAircraftByMaker,
            getModelAircraftStructures: getModelAircraftStructures,
            getFlightTimes: getFlightTimes,
            getModelAircraftFlights: getModelAircraftFlights,
            getTakeOffCapacities: getTakeOffCapacities,
            thereIataModelAircraft: thereIataModelAircraft,
            getModelAircraftsJoinStructures: getModelAircraftsJoinStructures
        };

        return service;

        function getModelAircrafts(){
            return $http.get(urlBase + "?detailed=true")
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findAllError('');
                });
        }

        function getPageModelAircrafts(page, size){
            return $http.get(urlBase + "/" + 'page?page=' + page + '&size=' + size + '&detailed=true')
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findAllError('');
                });
        }

        function getModelAircraft(makerId, modelAircraftId){
            return $http.get(urlBase + "/" + makerId + "_" + modelAircraftId);
        }

        function saveModelAircraft(modelAircraft){
            return $http.post(urlBase, modelAircraft)
                .then(function(res){
                    messageService.register('modelAircrafts');
                }, function(error){
                    messageService.registerError('modelAircrafts');
                });
        }

        function updateModelAircraft(modelAircraft){
            return $http.put(urlBase + "/" + modelAircraft.makerId + "_" + modelAircraft.modelAircraftId, modelAircraft)
                .then(function(){
                    messageService.registerUpdate('modelAircrafts');
                }, function(){
                    messageService.registerUpdateError('modelAircrafts');
                });
        }

        function deleteModelAircraft(makerId, modelAircraftId){
            return $http.delete(urlBase + "/" + makerId + "_" + modelAircraftId)
                .then(function(response){
                    messageService.registerDelete('modelAircrafts');
                    return response;
                })
                .catch(function(error){
                    if(error.data.message.indexOf('asociación')> -1 || error.data.message.indexOf('asociacion') > -1
                        || error.data.message.indexOf('association') > -1 || error.data.message.indexOf('associated') > -1){
                        messageService.registerDeleteGeneralError('modelAircrafts','air.modelAircraft.associatedStructures')
                    }else{
                        messageService.registerDeleteError('modelAircrafts')
                    }
                });
        }

        function getModelAircraftByMaker(id){
            return $http.get(urlBase + "/" + id + "/maker")
        }

        function getModelAircraftStructures(makerId, modelAircraftId){
            return $http.get(urlBase + "/" + makerId + "_" + modelAircraftId + "/structures")
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response){
                return response;
            }
            function getFailed(){
                messageService.findAllError('');
            }
        }

        function getFlightTimes(makerId, modelAircraftId){
            return $http.get(urlBase + "/" + makerId + "_" + modelAircraftId + "/flightTimes")
                .then(getModelAircraftFlightsComplete)
                .catch(getModelAircraftFlightsFailed);

            function getModelAircraftFlightsComplete(response){
                return response;
            }

            function getModelAircraftFlightsFailed(error) {
                messageService.findAllError('')
            }
        }

        function getModelAircraftFlights(dateTime){
            return $http.get(urlBase + "/flights/" + dateTime + "?detailed=true")
                .then(getModelAircraftFlightsComplete)
                .catch(getModelAircraftFlightsFailed);

            function getModelAircraftFlightsComplete(response){
                return (response.data._embedded) ? response.data._embedded.modelAircrafts : [];
            }

            function getModelAircraftFlightsFailed(error){
                messageService.findAllError('');
            }
        }

        function getTakeOffCapacities(makerId, modelAircraftId){
            return $http.get(urlBase + "/" + makerId + "_" + modelAircraftId + "/takeOffCapacities")
                .then(getModelAircraftFlightsComplete)
                .catch(getModelAircraftFlightsFailed);

            function getModelAircraftFlightsComplete(response){
                return (response.data._embedded) ? response.data._embedded.takeOffCapacities : [];
            }

            function getModelAircraftFlightsFailed(error) {
                messageService.findAllError('')
            }
        }

        function thereIataModelAircraft(iataCode) {
            return $http.get(urlBase + "/thereIataCode/" + iataCode, {headers: {'Loading-Overlay': false}})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('')
                });
        }

        function getModelAircraftsJoinStructures(){
            return $http.get(urlBase + "/joinStructures?detailed=true")
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findAllError('');
                });
        }
    }
})();

